import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    if (this.props.fallback) return this.props.fallback;
    return (
      <div className="min-h-[70vh] bg-[#050505] text-white px-6 py-16 max-w-3xl mx-auto" data-testid="app-error-screen">
        <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#cfff04] mb-3">// SolSpur</div>
        <h1 className="font-display text-3xl font-black uppercase tracking-tighter mb-3">
          Something broke on this page.
        </h1>
        <p className="text-[#e2e2e2] text-sm mb-6">
          Reload usually fixes it. If it keeps happening, screenshot this page and send it to support.
        </p>
        <button
          onClick={() => window.location.reload()}
          data-testid="app-error-reload"
          className="btn-brutal bg-[#cfff04] text-[#050505] font-bold uppercase tracking-wider text-sm px-6 py-3"
        >
          Reload
        </button>
        <pre className="mt-8 p-4 bg-[#121212] border border-[#3a3a3a] text-[#ff6b6b] font-mono text-[11px] whitespace-pre-wrap break-words" data-testid="app-error-detail">
          {String(this.state.error?.message || this.state.error)}
        </pre>
      </div>
    );
  }
}
